import { Component, Input, OnChanges, OnInit, SimpleChanges } from "@angular/core";
import { UserService } from "app/@core/data/users.service";

@Component({
    selector: 'media-watermark',
    template: `
        <p class="watermark" [ngClass]="{ 'fullscreen': isFullscreen, 'picture': isPicture, 'miniature': miniatureDisplay }">
            <span class="date">{{ currentDate | date: 'dd/MM/yyyy HH:mm:ss' }}</span>
            <span class="plates">{{ mediaPlates }}/{{ mediaPrefix }}</span><br>
            E-mail: {{ userEmail }}
        </p>
        <div class="logo" [ngClass]="{ 'fullscreen-logo': isFullscreen }"></div>
    `,
    styles: [`
        .watermark {
            text-align: left;
            font-size: 0.7vw;
            white-space: nowrap;
            margin-top: 1%;
            height: 40px;
            top: 5px;
            right: 20px;
            position: absolute;
            color: white;
            opacity: 0.6;
            .date {
                margin-right: 10px;
            }
            .plates {
                font-weight: bold;
            }
        }
        .watermark.fullscreen {
            font-size: 30px;
            margin-left: 60%;
            right: 30px;
            text-align: left;
        }
        .watermark.picture {
            font-size: 1.3vh;
            white-space: nowrap;
            overflow: hidden;
            margin-left: 60%;
            height: 40px;
            right: 10px;
        }
        .watermark.miniature {
            font-size: 1vh;
            overflow: hidden;
            margin-top: 1%;
            margin-left: 60%;
            height: 40px;
            right: 10px;
            position: absolute;
            color: white;
            opacity: 0.6;
        }
        .logo {
            position: absolute;
            margin-bottom: 40px;
            bottom: 30px;
            left: 20px;
            background: url(../../../../assets/images/logo_logoWaterMark.png);
            background-size: cover;
            aspect-ratio: 3.5;
            width: 20%;
            opacity: 0.6;
        }
        .logo.fullscreen-logo {
            bottom: 150px;
        }
    `]
})
export class MediaWatermarkComponent implements OnInit, OnChanges {
    @Input() isFullscreen: boolean = false;
    @Input() isPicture: boolean;
    @Input() mediaPlates: string;
    @Input() mediaPrefix: string;
    @Input() miniatureDisplay: boolean = false;
    public currentDate: Date = new Date();
    public userEmail: string = "";

    constructor(private userService: UserService) {
    }

    ngOnInit() {
        this.userService.getUserEmail().subscribe((result) => {
            this.userEmail = result;
        });
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['isFullscreen']) {
            this.miniatureDisplay = !changes['isFullscreen'].currentValue;
        }
    }
}